"use strict";
var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var queryable_1 = require("./queryable");
var FileUtil = require("../../utils/files");
var odata_1 = require("./odata");
var UserProfileQuery = (function (_super) {
    __extends(UserProfileQuery, _super);
    function UserProfileQuery(baseUrl, path) {
        if (path === void 0) { path = "_api/sp.userprofiles.peoplemanager"; }
        _super.call(this, baseUrl, path);
        this.profileLoader = new ProfileLoader(baseUrl);
    }
    Object.defineProperty(UserProfileQuery.prototype, "editProfileLink", {
        get: function () {
            var q = new UserProfileQuery(this, "EditProfileLink");
            return q.getAs(odata_1.ODataValue());
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(UserProfileQuery.prototype, "isMyPeopleListPublic", {
        get: function () {
            var q = new UserProfileQuery(this, "IsMyPeopleListPublic");
            return q.getAs(odata_1.ODataValue());
        },
        enumerable: true,
        configurable: true
    });
    UserProfileQuery.prototype.amIFollowedBy = function (loginName) {
        var q = new UserProfileQuery(this, "amifollowedby(@v)");
        q.query.add("@v", "'" + encodeURIComponent(loginName) + "'");
        return q.get();
    };
    UserProfileQuery.prototype.amIFollowing = function (loginName) {
        var q = new UserProfileQuery(this, "amifollowing(@v)");
        q.query.add("@v", "'" + encodeURIComponent(loginName) + "'");
        return q.get();
    };
    UserProfileQuery.prototype.getFollowedTags = function (maxCount) {
        if (maxCount === void 0) { maxCount = 20; }
        var q = new UserProfileQuery(this, "getfollowedtags(" + maxCount + ")");
        return q.get();
    };
    UserProfileQuery.prototype.getFollowersFor = function (loginName) {
        var q = new UserProfileQuery(this, "getfollowersfor(@v)");
        q.query.add("@v", "'" + encodeURIComponent(loginName) + "'");
        return q.get();
    };
    Object.defineProperty(UserProfileQuery.prototype, "myFollowers", {
        get: function () {
            return new queryable_1.QueryableCollection(this, "getmyfollowers");
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(UserProfileQuery.prototype, "myProperties", {
        get: function () {
            return new UserProfileQuery(this, "getmyproperties");
        },
        enumerable: true,
        configurable: true
    });
    UserProfileQuery.prototype.getPeopleFollowedBy = function (loginName) {
        var q = new UserProfileQuery(this, "getpeoplefollowedby(@v)");
        q.query.add("@v", "'" + encodeURIComponent(loginName) + "'");
        return q.get();
    };
    UserProfileQuery.prototype.getPropertiesFor = function (loginName) {
        var q = new UserProfileQuery(this, "getpropertiesfor(@v)");
        q.query.add("@v", "'" + encodeURIComponent(loginName) + "'");
        return q.get();
    };
    Object.defineProperty(UserProfileQuery.prototype, "trendingTags", {
        get: function () {
            var q = new UserProfileQuery(this, null);
            q.concat(".gettrendingtags");
            return q.get();
        },
        enumerable: true,
        configurable: true
    });
    UserProfileQuery.prototype.getUserProfilePropertyFor = function (loginName, propertyName) {
        var q = new UserProfileQuery(this, "getuserprofilepropertyfor(accountname=@v, propertyname='" + propertyName + "')");
        q.query.add("@v", "'" + encodeURIComponent(loginName) + "'");
        return q.get();
    };
    UserProfileQuery.prototype.hideSuggestion = function (loginName) {
        var q = new UserProfileQuery(this, "hidesuggestion(@v)");
        q.query.add("@v", "'" + encodeURIComponent(loginName) + "'");
        return q.post();
    };
    UserProfileQuery.prototype.isFollowing = function (follower, followee) {
        var q = new UserProfileQuery(this, null);
        q.concat(".isfollowing(possiblefolloweraccountname=@v, possiblefolloweeaccountname=@y)");
        q.query.add("@v", "'" + encodeURIComponent(follower) + "'");
        q.query.add("@y", "'" + encodeURIComponent(followee) + "'");
        return q.get();
    };
    UserProfileQuery.prototype.setMyProfilePic = function (profilePicSource) {
        var _this = this;
        return FileUtil.readBlobAsArrayBuffer(profilePicSource).then(function (buffer) {
            var request = new UserProfileQuery(_this, "setmyprofilepicture");
            return request.post({
                body: String.fromCharCode.apply(null, new Uint16Array(buffer)),
            });
        });
    };
    UserProfileQuery.prototype.createPersonalSiteEnqueueBulk = function () {
        var emails = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            emails[_i - 0] = arguments[_i];
        }
        return this.profileLoader.createPersonalSiteEnqueueBulk(emails);
    };
    Object.defineProperty(UserProfileQuery.prototype, "ownerUserProfile", {
        get: function () {
            return this.profileLoader.ownerUserProfile;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(UserProfileQuery.prototype, "userProfile", {
        get: function () {
            return this.profileLoader.userProfile;
        },
        enumerable: true,
        configurable: true
    });
    UserProfileQuery.prototype.createPersonalSite = function (interactiveRequest) {
        if (interactiveRequest === void 0) { interactiveRequest = false; }
        return this.profileLoader.createPersonalSite(interactiveRequest);
    };
    UserProfileQuery.prototype.shareAllSocialData = function (share) {
        return this.profileLoader.shareAllSocialData(share);
    };
    return UserProfileQuery;
}(queryable_1.QueryableInstance));
exports.UserProfileQuery = UserProfileQuery;
var ProfileLoader = (function (_super) {
    __extends(ProfileLoader, _super);
    function ProfileLoader(baseUrl, path) {
        if (path === void 0) { path = "_api/sp.userprofiles.profileloader.getprofileloader"; }
        _super.call(this, baseUrl, path);
    }
    ProfileLoader.prototype.createPersonalSiteEnqueueBulk = function (emails) {
        var q = new ProfileLoader(this, "createpersonalsiteenqueuebulk");
        var postBody = JSON.stringify({ "emailIDs": emails });
        return q.post({
            body: postBody,
        });
    };
    Object.defineProperty(ProfileLoader.prototype, "ownerUserProfile", {
        get: function () {
            var q = this.getParent(ProfileLoader, this.parentUrl, "_api/sp.userprofiles.profileloader.getowneruserprofile");
            return q.postAs();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ProfileLoader.prototype, "userProfile", {
        get: function () {
            var q = new ProfileLoader(this, "getuserprofile");
            return q.postAs();
        },
        enumerable: true,
        configurable: true
    });
    ProfileLoader.prototype.createPersonalSite = function (interactiveRequest) {
        if (interactiveRequest === void 0) { interactiveRequest = false; }
        var q = new ProfileLoader(this, "getuserprofile/createpersonalsiteenque(" + interactiveRequest + ")\",");
        return q.post();
    };
    ProfileLoader.prototype.shareAllSocialData = function (share) {
        var q = new ProfileLoader(this, "getuserprofile/shareallsocialdata(" + share + ")\",");
        return q.post();
    };
    return ProfileLoader;
}(queryable_1.Queryable));
